import { render, staticRenderFns } from "./MoleculeSidebarResultSpaceDetails.vue?vue&type=template&id=406efa18&"
import script from "./MoleculeSidebarResultSpaceDetails.vue?vue&type=script&lang=js&"
export * from "./MoleculeSidebarResultSpaceDetails.vue?vue&type=script&lang=js&"
import style0 from "./MoleculeSidebarResultSpaceDetails.vue?vue&type=style&index=0&id=406efa18&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "@/lang/MoleculeSidebarResultSpaceDetails.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fapp%2Fcomponents%2Fmolecules%2Fproject%2Fbuilding%2FMoleculeSidebarResultSpaceDetails.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports